import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">They may want to consider the
                                                following points:
                                            </div>
                                            <ul className="greenbullet-list">

                                                <li>Are they motivated by receiving reward or recognition?</li>
                                                <li>They seem to like working with others and have identified
                                                    social aspects as a ‘driver’ for them. Are these linked
                                                    together? If so how?
                                                </li>
                                                <li>Which are their strongest values, preferences and
                                                    motivators?
                                                </li>
                                                <li className="list-bottom-pad">They say that they may take
                                                    calculated risks. How would they balance this with their
                                                    intention to behave with integrity?
                                                </li>


                                            </ul>
                                            <p>Like the person in this example, you may appear to have
                                                consistent threads linking your values with your motivations, or
                                                they may be less clear. Don’t worry if your values, preferences
                                                and motivators don’t seem to link up; this tool is about raising
                                                your awareness of what you want in order to reappraise the work
                                                that you do now, or would like to do.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>HINTS AND TIPS
                                            </div>
                                            <div className="border_subtitle">The following hints and tips can be
                                                applied to many core value combinations:
                                            </div>
                                            <ol className="testclass sept">
                                                <li><p className="further_info_content">Once you have identified
                                                    the values that are most important to you, consider whether
                                                    they’re catered for in your current role or type of work.
                                                    What does this mean in terms of what you are doing now and
                                                    what you really want to achieve?</p></li>

                                                <li><p className="further_info_content">Consider how your values
                                                    and preferences guide your behaviour and actions.</p>
                                                    <p style={{paddingLeft:'22px'}}><span
                                                        className="hitandtip">a)</span> <span
                                                        className="hitandtip1">Draw a vertical line down the middle of an A4 sheet.</span>
                                                    </p>
                                                    <p style={{paddingLeft:'22px'}}><span
                                                        className="hitandtip">b)</span> <span
                                                        className="hitandtip1">On the left side write the most important preferences you have identified. Spread them out evenly.</span>
                                                    </p>
                                                    <p style={{paddingLeft:'22px'}}><span
                                                        className="hitandtip">c)</span> <span
                                                        className="hitandtip1">On the right hand side of the page, think about the main behaviours that you demonstrate.</span>
                                                    </p>
                                                    <p style={{paddingLeft:'22px'}}><span
                                                        className="hitandtip">d)</span> <span
                                                        className="hitandtip1">Try to note down 10-15 behaviours; for example, project management, line manager to four people. Number each behaviour.</span>
                                                    </p>
                                                    <div className="paraspace"><p style={{paddingLeft:'22px'}}>
                                                        <span className="hitandtip">e)</span><span
                                                        className="hitandtip1">Below each dimension, note down the behaviours (by number) that these guide in your work. (You may have some you can’t categorise.)</span>
                                                    </p></div>
                                                    <p className="further_info_content">This should help you
                                                        recognise how you behave according to your personal
                                                        values and preferences in your job. Think about the
                                                        things that you’d like to be doing, what you could do
                                                        more or less of, in order to work according to your
                                                        values and preferences. The closer the match between
                                                        your work and your values the easier it’s likely to be
                                                        for you to carry out your day-to-day activities.</p>
                                                </li>
                                                <li><p className="further_info_content"> Consider the values
                                                    which you have ticked and especially those which you have
                                                    double ticked. How much does your current job allow you to
                                                    live your values and do the kind of things you prefer? You
                                                    may want to refer to your original job description, if you
                                                    have one, to help remind you what your job’s really all
                                                    about!</p>
                                                    <p className="further_info_content">Think about how your
                                                        values and preferences impact others. Consider whether
                                                        others know what your core values and preferences
                                                        are.</p></li>
                                                <li><p className="further_info_content">Talk to your team
                                                    members and arrange for some time, for example on an ‘away
                                                    day’ or during a team meeting, where you can discuss your
                                                    values and preferences and those of your team. You may want
                                                    to get your team to complete the ‘Why do I do this job?’
                                                    exercise, too!</p></li>
                                            </ol>
                                        </div>


                                        <div className="left-btn">
                                            <div onClick={this.props.handleChangePage('Page6')}
                                                 className="button-next-previous-done">&lt;&lt; Previous
                                            </div>
                                        </div>
                                        <div className="right-btn">
                                            <div onClick={this.props.handleChangePage('Page8')}
                                                 className="button-next-previous-done">Next &gt;&gt;</div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}